import { gql, useQuery } from '@apollo/client';

import { ignorePermissionsErrors } from 'src/lib/apollo/catchErrors';
import { appLinkContext } from 'src/lib/apollo/link';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { useCurrentAccountId } from './useCurrentAccountId';

export const useCapabilities = (skip?: boolean) => {
  const [accountId] = useCurrentAccountId();

  const { loading, data, error } = useQuery<
    GraphQLTypes.UseCapabilitiesQuery,
    GraphQLTypes.UseCapabilitiesQueryVariables
  >(
    gql`
      query UseCapabilitiesQuery($accountId: ID!) {
        account(id: $accountId) {
          id
          capabilities {
            connectorsInRouter
            proposals
            webhooks
            persistedQueries
            launches
            clients
            metrics
            cloudGraphs

            # Currently unused capabilities, uncomment if needed
            # clientVersions
            # contracts
            # customSessionLengths
            # datadog
            # federation
            # linting
            # notifications
            # operationRegistry
            # schemaValidation
            # sso
            traces
            # userRoles
          }
        }
      }
    `,
    {
      variables: { accountId: accountId as NonNullable<typeof accountId> },
      skip: !accountId || skip,
      context: appLinkContext({ catchErrors: [ignorePermissionsErrors] }),
    },
  );

  return { capabilities: data?.account?.capabilities, loading, error };
};
